import { render, staticRenderFns } from "./Desktop_Header.vue?vue&type=template&id=da6e042a&scoped=true&"
import script from "./Desktop_Header.vue?vue&type=script&lang=js&"
export * from "./Desktop_Header.vue?vue&type=script&lang=js&"
import style0 from "./Desktop_Header.vue?vue&type=style&index=0&id=da6e042a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6e042a",
  null
  
)

export default component.exports